module.exports = __webpack_public_path__ + "static/media/varie6f.a3efb3bd.jpg";